import React from 'react';
import '../../../assets/scss/components/app-loader.scss';
class SpinnerComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        className="fallback-spinner "
        style={{ height: this.props.height || '100vh' }}
      >
        {/* <img className="fallback-logo" src={logo} alt="logo" /> */}
        <div className="loading">
          <div className="effect-1 effects"></div>
          <div className="effect-2 effects"></div>
          <div className="effect-3 effects"></div>
        </div>
      </div>
    );
  }
}

export default SpinnerComponent;
